export const CHANGE_PASSWORD_OPEN_DIALOG = 'CHANGE_PASSWORD_OPEN_DIALOG';
export const CHANGE_PASSWORD_CLOSE_DIALOG = 'CHANGE_PASSWORD_CLOSE_DIALOG';
export const CHANGE_PHONE_PASSWORD_OPEN_DIALOG =
  'CHANGE_PHONE_PASSWORD_OPEN_DIALOG';
export const CHANGE_PHONE_PASSWORD_CLOSE_DIALOG =
  'CHANGE_PHONE_PASSWORD_CLOSE_DIALOG';
export const CREATE_PHONE_LOGIN_OPEN_DIALOG = 'CREATE_PHONE_LOGIN_OPEN_DIALOG';
export const CREATE_PHONE_LOGIN_CLOSE_DIALOG =
  'CREATE_PHONE_LOGIN_CLOSE_DIALOG';

export const openDialog = () => ({
  type: CHANGE_PASSWORD_OPEN_DIALOG,
});

export const closeDialog = () => ({
  type: CHANGE_PASSWORD_CLOSE_DIALOG,
});

export const openCreatePhoneLoginDialog = () => ({
  type: CREATE_PHONE_LOGIN_OPEN_DIALOG,
});

export const closeCreatePhoneLoginDialog = () => ({
  type: CREATE_PHONE_LOGIN_CLOSE_DIALOG,
});

export const openChangePhonePasswordDialog = () => ({
  type: CHANGE_PHONE_PASSWORD_OPEN_DIALOG,
});

export const closeChangePhonePasswordDialog = () => ({
  type: CHANGE_PHONE_PASSWORD_CLOSE_DIALOG,
});
